module.exports = __webpack_public_path__ + "media/images/sample/eyecatch-feature-4451c222ed0a0fec317a902d422787bb.png";